import SeoHead, { localBusinessJsonLd } from "@/components/SeoHead";
import QuoteForm from "@/components/QuoteForm";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "@/data/siteData";

export default function Contact() {
  return (
    <>
      <SeoHead
        title={`Contact - ${SITE.name}`}
        description={`Contactez ${SITE.name} pour un devis gratuit. Adresse : ${SITE.address.street}, ${SITE.address.postalCode} ${SITE.address.city}. Tél ${SITE.phoneDisplay}.`}
        canonicalPath="/contact"
        jsonLd={localBusinessJsonLd()}
      />
      <section className="relative bg-white">
        <div className="absolute inset-0 dh-radial-glow pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-16 grid lg:grid-cols-2 gap-12">
          <div>
            <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">Contact</div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-[#00367e] leading-[1.05]">
              Parlons de <span className="dh-underline">votre cuisine</span>
            </h1>
            <p className="mt-6 text-lg text-slate-700">
              Une question, un devis, une urgence ? Notre équipe vous répond rapidement, 7j/7 - 24h/24.
            </p>

            <div className="mt-10 space-y-5">
              <a href={`tel:${SITE.phoneTel}`} className="flex items-center gap-4 group" data-testid="contact-phone">
                <span className="w-14 h-14 rounded-2xl bg-[#00367e] text-white flex items-center justify-center"><Phone size={22} /></span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Téléphone</div>
                  <div className="text-2xl font-bold text-[#00367e] group-hover:text-[#066ec4]">{SITE.phoneDisplay}</div>
                </div>
              </a>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 group" data-testid="contact-email">
                <span className="w-14 h-14 rounded-2xl bg-[#066ec4] text-white flex items-center justify-center"><Mail size={22} /></span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Email</div>
                  <div className="text-lg font-bold text-[#00367e] group-hover:text-[#066ec4]">{SITE.email}</div>
                </div>
              </a>
              <div className="flex items-center gap-4">
                <span className="w-14 h-14 rounded-2xl bg-slate-100 text-[#00367e] flex items-center justify-center"><MapPin size={22} /></span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Adresse</div>
                  <div className="text-lg font-bold text-[#00367e]">
                    {SITE.address.street}<br/>{SITE.address.postalCode} {SITE.address.city}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-14 h-14 rounded-2xl bg-slate-100 text-[#00367e] flex items-center justify-center"><Clock size={22} /></span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Horaires</div>
                  <div className="text-lg font-bold text-[#00367e]">{SITE.hoursLabel}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,54,126,0.15)] border border-slate-100 aspect-square lg:aspect-auto lg:min-h-[500px]">
            <iframe
              title="Carte Dégraissage Hotte Melun"
              src={`https://www.google.com/maps?q=${encodeURIComponent(SITE.address.street + ", " + SITE.address.postalCode + " " + SITE.address.city)}&output=embed`}
              width="100%" height="100%"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0, minHeight: 500 }}
              data-testid="contact-map"
            />
          </div>
        </div>
      </section>
      <QuoteForm />
    </>
  );
}
